import React from "react"
import ReactDOM from "react-dom"
import NewsOverviewBlock from "./news-overview-block-component"

export default class NewsOverviewBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.newsItems = elem.dataset.newsItems && JSON.parse(elem.dataset.newsItems)
    self.newsCategories = elem.dataset.selectedNewsCategories && JSON.parse(elem.dataset.selectedNewsCategories)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NewsOverviewBlock {...self.modelJson} news={self.newsItems} newsCategories={self.newsCategories} />, self.elem)
  }
}
